import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {LoaderService} from '../services/loader.service';
import {MyStorageService} from '../services/my-storage.service';
import {Constants} from '../utils/constants';
import {ErrorHandlerService} from "../services/error-handler.service";


@Injectable()
export class LoaderInterceptor {

  constructor(public loaderService: LoaderService,
              private myStorage:MyStorageService,
              private errorHandlerService: ErrorHandlerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();

    const clonedRequest = req.clone({ headers: req.headers.set('Accept-Language', this.myStorage.getFromCookies(Constants.STORAGE_KEYS.LANGUAGE, Constants.DEFAULT_LANGUAGE)+'-HU') });
    return next.handle(clonedRequest).pipe(
      catchError((err: any) => {
        this.errorHandlerService.handleError(err);
        return of(err);
      }),
      finalize(() => this.loaderService.hide())
    );
  }
}
